(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bright-side-topics"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bright-topics-slider')) {
    customElements.define('bright-topics-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.bar = this.querySelector('[data-bar]');
        this.controls = this.querySelector('[data-controls]');
        if (!this.track) return;

        this.update = this.update.bind(this);
        this.prev.addEventListener('click', () => this.go(-1));
        this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }
      step() {
        const item = this.track.querySelector('.bright-topics__item');
        if (!item) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      go(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
      }
      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        const scrollable = max > 4;
        this.controls.hidden = !scrollable;
        if (!scrollable) return;

        this.prev.disabled = t.scrollLeft <= 4;
        this.next.disabled = t.scrollLeft >= max - 4;

        const size = (t.clientWidth / t.scrollWidth) * 100;
        const pos = (t.scrollLeft / max) * (100 - size);
        this.bar.style.width = size + '%';
        this.bar.style.left = pos + '%';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kefey-page"]) return;
  try {
    
  if (!customElements.get('ka-toc')) {
    customElements.define('ka-toc', class extends HTMLElement {
      connectedCallback() {
        const root = this.closest('.ka');
        const content = root && root.querySelector('[data-article-content]');
        const list = this.querySelector('[data-toc-list]');
        this.details = this.querySelector('[data-toc-details]');
        if (!content || !list) return;

        const headings = Array.from(content.querySelectorAll('h2'));
        if (!headings.length) {
          const wrap = this.closest('[data-toc-wrap]');
          if (wrap) wrap.style.display = 'none';
          return;
        }

        const used = {};
        this.links = headings.map((h) => {
          let id = h.id || h.textContent.trim().toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').slice(0, 60) || 'section';
          if (used[id]) { used[id] += 1; id = id + '-' + used[id]; } else { used[id] = 1; }
          h.id = id;

          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + id;
          link.textContent = h.textContent.trim();
          link.addEventListener('click', (e) => {
            e.preventDefault();
            h.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, '', '#' + id);
            if (!this.mq.matches) this.details.open = false;
          });
          li.appendChild(link);
          list.appendChild(li);
          return { h, link };
        });

        /* Desktop: always open. Mobile: collapsible */
        this.mq = window.matchMedia('(min-width: 990px)');
        const sync = () => { this.details.open = this.mq.matches; };
        sync();
        this.mq.addEventListener('change', sync);

        /* Highlight the section being read */
        const setActive = (id) => {
          this.links.forEach(({ h, link }) => link.classList.toggle('is-active', h.id === id));
        };
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => { if (en.isIntersecting) setActive(en.target.id); });
        }, { rootMargin: '-120px 0px -65% 0px' });
        headings.forEach((h) => io.observe(h));
        setActive(headings[0].id);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kefey-star-journal"]) return;
  try {
    
  if (!customElements.get('ka-toc')) {
    customElements.define('ka-toc', class extends HTMLElement {
      connectedCallback() {
        const root = this.closest('.ka');
        const content = root && root.querySelector('[data-article-content]');
        const list = this.querySelector('[data-toc-list]');
        this.details = this.querySelector('[data-toc-details]');
        if (!content || !list) return;

        const headings = Array.from(content.querySelectorAll('h2'));
        if (!headings.length) {
          const wrap = this.closest('[data-toc-wrap]');
          if (wrap) wrap.style.display = 'none';
          return;
        }

        const used = {};
        this.links = headings.map((h) => {
          let id = h.id || h.textContent.trim().toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').slice(0, 60) || 'section';
          if (used[id]) { used[id] += 1; id = id + '-' + used[id]; } else { used[id] = 1; }
          h.id = id;

          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + id;
          link.textContent = h.textContent.trim();
          link.addEventListener('click', (e) => {
            e.preventDefault();
            h.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, '', '#' + id);
            if (!this.mq.matches) this.details.open = false;
          });
          li.appendChild(link);
          list.appendChild(li);
          return { h, link };
        });

        /* Desktop: always open. Mobile: collapsible */
        this.mq = window.matchMedia('(min-width: 990px)');
        const sync = () => { this.details.open = this.mq.matches; };
        sync();
        this.mq.addEventListener('change', sync);

        /* Highlight the section being read */
        const setActive = (id) => {
          this.links.forEach(({ h, link }) => link.classList.toggle('is-active', h.id === id));
        };
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => { if (en.isIntersecting) setActive(en.target.id); });
        }, { rootMargin: '-120px 0px -65% 0px' });
        headings.forEach((h) => io.observe(h));
        setActive(headings[0].id);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
